export { default } from './Copiable';
